module.exports = __webpack_public_path__ + "img/easel.c141ed28.png";